import type { RecipeProduct } from "../../../shared/production/recipe-cost";
import type { ProductionWorkspacePlanRow } from "../../../shared/production/workspace-report";

export type PlannedProduct = RecipeProduct & { date: string; quantity: number; lineNames: string[] };

export function plannedCostProducts(planRows: ProductionWorkspacePlanRow[]): PlannedProduct[] {
  const grouped = new Map<string, PlannedProduct>();
  for (const row of planRows.filter(item => item.level === "FINAL_19")) {
    const key = `${row.date}/${row.productCode}`;
    const current = grouped.get(key);
    if (current) {
      current.quantity += row.quantity;
      if (row.lineName && !current.lineNames.includes(row.lineName)) current.lineNames.push(row.lineName);
    } else grouped.set(key, {
      code: row.productCode, name: row.productName, unit: row.unit ?? "", date: row.date,
      quantity: row.quantity, lineNames: row.lineName ? [row.lineName] : [],
      units: row.unit ? [{ position: 1, name: row.unit, factor: 1 }] : [],
    });
  }
  return [...grouped.values()].sort((a, b) => a.date.localeCompare(b.date) || a.code.localeCompare(b.code));
}
